var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"controls__button",on:{"click":function($event){return _vm.handleClick( $event )}}})
}
var staticRenderFns = []

export { render, staticRenderFns }